<template>
    <TextClamp
        v-bind="$attrs"
        ref="clamp">
        <template
            v-for="(_, slot) of $slots"
            v-slot:[slot]="scope">
            <slot
                :name="slot"
                v-bind="scope"></slot>
        </template>
        <slot></slot>
    </TextClamp>
</template>

<script>
import TextClamp from 'vue3-text-clamp';

export default {
    name: 'Clamp',
    components: {
        TextClamp,
    },
    props: {
        showToggle: {
            type: Boolean,
            default: false,
        },
    },
};
</script>
